import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from "@angular/forms";

@Component({
  selector: 'app-datepickerv2-input',
  templateUrl: './datepickerv2-input.component.html',
  styleUrls: ['./datepickerv2-input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class Datepickerv2InputComponent {
  @Output('valueChanged') valueChanged = new EventEmitter();
  @Output('touched') touched = new EventEmitter<void>();

  @Input('parentForm') parentForm: UntypedFormGroup;
  @Input('controlName') controlName: string;
  @Input('whiteBg') whiteBg: boolean = false;
  @Input('placeholder') placeholder: string = 'DD/MM/YYYY';
  @Input('min') min: Date = null;
  @Input('max') max: Date = null;
  @Input('startView') startView: 'month' | 'year' | 'multi-year' = 'month';

  handleTouched()
  {
    this.touched.emit();
  }
}
